import { Link } from 'react-router-dom';

import { Flex as FlexNew } from 'shared';
import Box from 'shared_DEPRECATED/components/Box';
import { FlexItem, Flex } from 'shared_DEPRECATED/components/Flex';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import {
  GoalBadge,
  GoalCardTitle,
  GoalImage,
  useGoalsNavigationLink,
  VISIBLE_DIMENSIONS_COUNT,
} from 'features/goal';
import { IGoal__DEPRECATED } from 'features/goal/types';
import { LifeDimensions } from 'features/lifeDimensions/components/LifeDimensions';

import { Createdat } from './Createdat';

type ReadonlyGoalCardProps = {
  goal: IGoal__DEPRECATED;
  dataTestid?: string;
  participantEmail?: string;
};

export const ReadonlyGoalCard = ({
  goal,
  dataTestid,
  participantEmail,
}: ReadonlyGoalCardProps) => {
  const url = useGoalsNavigationLink(participantEmail);
  const {
    goalId,
    name,
    dimensions,
    deadline,
    completedAt,
    cover,
    createdAt,
    prioritizedAt,
    columnLabel,
  } = goal;

  const cardBackgroundColor = !!completedAt
    ? 'linear-gradient(180deg, var(--bgCompPrimary) 10%, var(--bgCompMinorSuccess) 90%)'
    : 'var(--bgCompPrimary)';

  return (
    <Box
      style={{
        background: cardBackgroundColor,
        minHeight: '50px',
        width: '100%',
        borderRadius: 'var(--border-radius)',
      }}
      dataTestid={dataTestid}
    >
      <Link to={`${url}/${goalId}`} style={{ textDecoration: 'none' }}>
        <FlexItem flexGrow={1}>
          <Spacer size="md">
            <Flex
              flexDirection="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              gap="var(--spacing01)"
            >
              <Flex
                justifyContent="space-between"
                width="100%"
                alignItems="flex-start"
              >
                <Flex
                  flexDirection="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >
                  <GoalCardTitle name={name} />
                  <LifeDimensions
                    dimensions={dimensions}
                    visibleDimensionsCount={VISIBLE_DIMENSIONS_COUNT}
                    maxWidth="13rem"
                  />
                  {createdAt ? <Createdat createdAt={createdAt} /> : ''}
                </Flex>
                <GoalImage imageUrl={cover?.url} />
              </Flex>
              <Spacer size="xsm" />
              <FlexNew alignItems="center" gap="var(--spacing01)">
                <GoalBadge
                  deadline={deadline}
                  completedAt={completedAt}
                  years={columnLabel}
                />
                <Icon
                  name={iconNames.flagNew}
                  fill={getPriorityIconColors(!!prioritizedAt).fill}
                  stroke={getPriorityIconColors(!!prioritizedAt).stroke}
                />
              </FlexNew>
            </Flex>
          </Spacer>
        </FlexItem>
      </Link>
    </Box>
  );
};

const getPriorityIconColors = (isPrioritized: boolean) =>
  isPrioritized
    ? {
        fill: 'var(--fgInteractive)',
        stroke: 'var(--fgInteractive)',
      }
    : {
        fill: 'var(--white)',
        stroke: '#5F6368',
      };
